import React from 'react';
import PropTypes from 'prop-types';
import { Box, Subhead } from 'rebass';
import styled from 'styled-components';
import Emoji from '../../app/components/emoji';
import Content from '../../app/components/content';

const Title = styled(Subhead)`
  letter-spacing: 0.05em;
  line-height: 1.5;
`;

const Paragraph = ({ emoji, title, children }) => (
  <Box mb={4}>
    <Title
      f={1}
      mb={2}
      caps
    >
      {
        emoji &&
          <Emoji>
            {emoji}
          </Emoji>
      }
      {' '}{title}
    </Title>
    <Content pb={2}>
      {children}
    </Content>
  </Box>
);

Paragraph.propTypes = {
  emoji: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

Paragraph.defaultProps = {
  emoji: null,
  title: null,
  children: null,
};

export default Paragraph;



// WEBPACK FOOTER //
// ./src/Details/paragraph/index.js